export interface MileageNumberArgs {
  id: number | null;
  carrier: string;
  number: string;
}

export default class MileageNumber {
  public id: number | null;

  public carrier: string;

  public number: string;

  constructor(args: MileageNumberArgs) {
    this.id = args.id;
    this.carrier = args.carrier;
    this.number = args.number;
  }
}
